/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AppSchemasSearchCriterionInput } from './appSchemasSearchCriterionInput';
import type { SearchFiltersSchema } from './searchFiltersSchema';

/**
 * API shape of a search definition: filters + criteria + rerank_query.
 *
 * Mirrors ``app.services.search.definition.SearchDefinition`` field-for-field
 * (same constraints). Kept as a separate class so the schemas layer never
 * imports from the services layer.
 */
export interface SearchDefinitionSchemaInput {
  filters?: SearchFiltersSchema;
  /** @maxItems 20 */
  criteria?: AppSchemasSearchCriterionInput[];
  rerank_query?: string | null;
  pool_ids?: string[] | null;
}
